export const bundleTypeEnum = {
  GAMES: 'games',
  JOKERS: 'jokers',
};
